import { Card, Bleed, Button, Collapsible, Divider, InlineStack, SkeletonBodyText, Text, BlockStack } from '@shopify/polaris';
import React, { useEffect, useMemo, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { findIndex } from 'lodash';
import { useTranslation } from 'react-i18next';
interface PropsI extends DIProps {
    data: any;
    data_loader: boolean
}
const OrderTimeline = (props: PropsI) => {
    const { t } = useTranslation();
    const label_generated = !!props.data?.shipping_services?.[0]?.label_generated

    const [orderTimeline, setOrderTimeline] = useState<any>(null);
    const [height, setHeight] = useState({ parent: 420, child: 0 });
    const [filledIdx, setFilledIdx] = useState(-1)
    const [loader, setLoader] = useState(false)

    const getOrderTimeline = () => {
        setLoader(true)
        props.di.POST('amazon/amazon-buy-shipping/getTracking', { 'carrier_id': props.data?.shipping_services?.[0]?.carrier_id, 'tracking_id': props?.data?.shipping_services[0].tracking_id, 'shop_id': props.redux?.current?.target?._id }).then((response) => {
            if (response.success) {
                setOrderTimeline(response.data)
            }
            setHeight({ parent: 420, child: 0 })
            setLoader(false)
        })

    }

    useEffect(() => {
        label_generated && getOrderTimeline();
    }, [props.data])

    const orderTrackedTo = useMemo(() => {
        let idx = orderTimeline?.eventHistory?.findIndex((a: any) => a.eventCode ===
            // "Departed")
            orderTimeline?.summary?.status)
        setFilledIdx(idx)
        if (idx > -1) {
            return 50 + idx * 92.5
        }
        return 50
    }, [orderTimeline])

    if (props.data_loader) return null
    return <>
        {!label_generated ?
            <Card>
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text variant="headingMd" as="h6">
                            {t("Order Timeline")}
                        </Text>
                        <InlineStack gap="100">
                            <Text as="p" fontWeight="regular">
                                {t("Tracking ID")}:
                            </Text>
                            <Text as="p" fontWeight="regular">
                                --
                            </Text>
                        </InlineStack>
                    </BlockStack>
                    <Bleed marginInline="500">
                        <Divider />
                    </Bleed>
                    <div className='italic'>
                        <InlineStack align='center'>
                            <Text variant="bodyLg" as="p" tone='subdued'>
                                {t("Keep track of your order here.")}
                            </Text>
                        </InlineStack>
                    </div>
                </BlockStack>
            </Card> :
            (loader ? <OrderTimelineSkeleton /> : orderTimeline && <Card>
                <BlockStack gap="500">
                    <BlockStack gap="100">
                        <Text variant="headingMd" as="h6">
                            {t("Order Timeline")}
                        </Text>
                        <InlineStack gap="100">
                            <Text as="p" fontWeight="regular">
                                {t("Tracking ID")}:
                            </Text>
                            <Text as="p" fontWeight="regular">
                                {orderTimeline?.trackingId ?? ''}
                            </Text>
                        </InlineStack>
                    </BlockStack>
                    <Bleed marginInline="500">
                        <Divider />
                    </Bleed>
                    <InlineStack gap="400">
                        <div className="vertical-progress-bar" style={{ height: `${height.parent}px` }}>
                            <div className="progress-wrapper">
                                <div className="progress-bar" style={{ height: `${orderTrackedTo + height.child}px` }}></div>
                            </div>
                        </div>
                        <BlockStack gap="500">
                            {orderTimeline.eventHistory.map((history: any, index: any) => {
                                return (
                                    <BlockStack gap="200">
                                        <BlockStack gap="100">
                                            <Text variant="headingMd" as="h6">
                                                {history?.eventCode.replace(/([A-Z])/g, ' $1').trim()}
                                            </Text>
                                            <div className='italic'>
                                                <Text variant="bodySm" as="p" tone='success' fontWeight="semibold">
                                                    {history?.eventTime && new Date(history.eventTime)?.toUTCString()}
                                                </Text>
                                            </div>
                                        </BlockStack>
                                        {history?.location && <CollapsedAddress location={history.location} setHeight={setHeight} index={index} filledIdx={filledIdx} />}
                                    </BlockStack>
                                );
                            })}
                        </BlockStack>
                    </InlineStack>
                </BlockStack>
            </Card>)}
    </>;
}

export default DI(OrderTimeline);

const CollapsedAddress = ({ location, setHeight, index, filledIdx }: { location: any, setHeight: React.Dispatch<React.SetStateAction<{ parent: number, child: number }>>, index: number, filledIdx: number }) => {
    const [show, setShow] = useState(false)
    return (
        <div>
            <Button
                size="slim"

                disclosure={'select'}
                onClick={() => {
                    if (!show) setHeight(a => ({ parent: a.parent + 92.5, child: index <= filledIdx ? a.child + 92.5 : a.child }))
                    else setHeight(a => ({ parent: a.parent - 92.5, child: index <= filledIdx ? a.child - 92.5 : a.child }))
                    setShow(a => !a)
                }}
                variant="plain">
                {show ? 'Hide Details' : 'Show Details'}
            </Button>
            <Collapsible
                open={show}
                id="basic-collapsible"
                transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
            >
                <BlockStack gap="100">
                    <InlineStack gap="100">
                        <Text as="p" fontWeight="regular" tone="subdued">
                            Region:
                        </Text>
                        <Text as="p" fontWeight="regular" tone="subdued">
                            {location.stateOrRegion}
                        </Text>
                    </InlineStack>
                    <InlineStack gap="100">
                        <Text as="p" fontWeight="regular" tone="subdued">
                            Country Code:
                        </Text>
                        <Text as="p" fontWeight="regular" tone="subdued">
                            {location.countryCode}
                        </Text>
                    </InlineStack>
                    <InlineStack gap="100">
                        <Text as="p" fontWeight="regular" tone="subdued">
                            City:
                        </Text>
                        <Text as="p" fontWeight="regular" tone="subdued">
                            {location.city}
                        </Text>
                    </InlineStack>
                    <InlineStack gap="100">
                        <Text as="p" fontWeight="regular" tone="subdued">
                            Postal code:
                        </Text>
                        <Text as="p" fontWeight="regular" tone="subdued">
                            {location.postalCode}
                        </Text>
                    </InlineStack>
                </BlockStack>
            </Collapsible>
        </div>
    );
}

const OrderTimelineSkeleton = () => {
    return (
        <Card>
            <BlockStack gap="500">
                <BlockStack gap="100">
                    <SkeletonBodyText />
                    <InlineStack gap="100">
                        <SkeletonBodyText lines={2} />
                    </InlineStack>
                </BlockStack>
                <Bleed marginInline="500">
                    <Divider />
                </Bleed>
                <BlockStack gap="100">
                    <SkeletonBodyText lines={2} />
                </BlockStack>
            </BlockStack>
        </Card>
    );
}